<template>
  <span :class="classes">
    <span class="js_toggle_popover">
      <RoundIcon
        v-if="!hideIcon"
        :icon="icon.icon"
        size="xxs"
        iconSize="xxs"
        theme="transparent"
        :icon-style="icon.iconStyle"
      />
      <span v-if="title" class="title">{{ title }}</span>
    </span>
    <span
      class="popover-content js_popover"
      :class="popoverColor"
      v-html="content"
    >
    </span>
  </span>
</template>

<script>
import './InfoButton.scss';
import { reactive, computed } from 'vue';
import RoundIcon from 'ewi-ui/components/2-molecules/RoundIcon';
import infoButton from './InfoButton.js';

export default {
  name: 'Info Button',
  components: { RoundIcon },
  props: {
    icon: {
      type: Object,
      default: () => ({
        icon: 'info',
        iconStyle: 'simple',
      }),
    },
    theme: {
      type: String,
      default: 'light',
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    popoverColor: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        'info-button': true,
        [`info-button__${props.theme}`]: true,
      })),
    };
  },

  mounted() {
    infoButton.init();
  },
};
</script>
